import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Validators } from '@angular/forms';
import { AbstractNestableOutputComponent } from '../abstract-nestable-output.component';

export let MAX_LENGTH = 50000;

// 50000 is too large and is slowing test significantly.
export function textAreaTestHelperAssignMax(newMaxlength: number) {
  MAX_LENGTH = newMaxlength;
}
@Component({
  selector: 'h3-text-area-output',
  templateUrl: './text-area-output.component.html',
  styleUrls: ['./text-area-output.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TextAreaOutputComponent extends AbstractNestableOutputComponent {
  maxLength = MAX_LENGTH;

  override setValidators() {
    super.setValidators();
    this.form.controls.input.addValidators(
      Validators.maxLength(this.maxLength),
    );
    this.form.controls.input.updateValueAndValidity();
  }

  override getUnsubmittableReason() {
    if (this.form.controls.input.hasError('maxlength')) {
      return 'A text area is over the character limit';
    }
    return super.getUnsubmittableReason();
  }
}
